import { SECOND_BAGGAGE } from '../../products';
import getGraphQlSelection from './utils/getGraphQlSelection';
const formSection = SECOND_BAGGAGE.name;
const secondBaggagePerTraveler = {
  getGraphQlSelection,
  formSection,
  ...SECOND_BAGGAGE
};
export default secondBaggagePerTraveler;
//# sourceMappingURL=index.js.map